import React, { useContext, useEffect, useState } from 'react';
import '../styles/basketItemDiscount.css';
import '../styles/summary.css';
import { Tag } from 'lucide-react';
import { useSelector } from 'react-redux';

export default function SelectedCoupon(props) {
    const direction = useSelector((state) => state.mode.direction);
    const isRtl = direction === "rtl";
    const discount = `-(₪${parseFloat(props.selectedCoupon.stand_alone_value).toFixed(2)})`;
    const message = props.selectedCoupon.message;
    const title = `${props.selectedCoupon.title}:`;

    return (
        <div
          className='content_selected_coupon'
          style={{ flexDirection: isRtl ? "row-reverse" : "row" }}
          data-testid="summary-selected-coupon"
        >
            <div className='box_item_l amount_ltr'>{discount}</div>
            <div className="summary_coupon_and_icon" style={{ flexDirection: isRtl ? "row-reverse" : "row" }}>
                <div className="summary_coupon_text" dir="auto">
                    <div className='box_item_r bold'>
                        {title}
                    </div>
                    <div className='box_item_l'>
                        {message}
                    </div>
                </div>
                <Tag size={20} />
            </div>
        </div>
    )
}
